module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAhCAYAAAALboFLAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD8SURBVHgB7ZTBbYQwEEW/RxHnLYESKCGuBDrYLYESdjtgO0gHe+GOS3AJKEIcjGVnfpRIkdj15hzlS4DtecwfWxobqKZpOizLctJha4yp9fEppWuM8WytnQ2BdV1vOecGe7lt26wwwwOAaqqqOoqqRUFq24lmqUsQayTkSxDjtBtKEOMSQrjo2D1gHOPCc+A21bv/tuaXc64zvvt1HMe8s8Qv9A/9ccjw9drlw5pw0lmLjFqXfAKuUXB2g5nNF3DTwN2+CwIrnxnuA1TzknBkTe2TojtCNcqqCfknkCc0lIiUoH0nKPZdXHARngO3iYT+h7XeT+jDO6x7M/MHob2DoWNCU94AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/orig-dest.png
// module id = 387b
// module chunks = 1